
// const url = 'http://192.168.2.128:3001'
// const urlClient = 'http://192.168.2.128:3000'

// on VI editor, these were active
const url = 'https://order.acgtinc.com:3001'
const urlClient = 'https://order.acgtinc.com'

// const muixlicensekey= "c8d4b234c7655de781a1569d518a0f4dTz0xMTAwOTksRT0xNzc0MTM3NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
const muixlicensekey="5fc7960f3cdf3ab5408f4a329cd3512dTz0xMjc3OTcsRT0xODA2Nzk2Nzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI="


const usa_states = [
	{ value: "AL", label: "Alabama" },
	{ value: "AK", label: "Alaska" },
	{ value: "AZ", label: "Arizona" },
	{ value: "AR", label: "Arkansas" },
	{ value: "CA", label: "California" },
	{ value: "CO", label: "Colorado" },
	{ value: "CT", label: "Connecticut" },
	{ value: "DE", label: "Delaware" },
	{ value: "FL", label: "Florida" },
	{ value: "GA", label: "Georgia" },
	{ value: "HI", label: "Hawaii" },
	{ value: "ID", label: "Idaho" },
	{ value: "IL", label: "Illinois" },
	{ value: "IN", label: "Indiana" },
	{ value: "IA", label: "Iowa" },
	{ value: "KS", label: "Kansas" },
	{ value: "KY", label: "Kentucky" },
	{ value: "LA", label: "Louisiana" },
	{ value: "ME", label: "Maine" },
	{ value: "MD", label: "Maryland" },
	{ value: "MA", label: "Massachusetts" },
	{ value: "MI", label: "Michigan" },
	{ value: "MN", label: "Minnesota" },
	{ value: "MS", label: "Mississippi" },
	{ value: "MO", label: "Missouri" },
	{ value: "MT", label: "Montana" },
	{ value: "NE", label: "Nebraska" },
	{ value: "NV", label: "Nevada" },
	{ value: "NH", label: "New Hampshire" },
	{ value: "NJ", label: "New Jersey" },
	{ value: "NM", label: "New Mexico" },
	{ value: "NY", label: "New York" },
	{ value: "NC", label: "North Carolina" },
	{ value: "ND", label: "North Dakota" },
	{ value: "OH", label: "Ohio" },
	{ value: "OK", label: "Oklahoma" },
	{ value: "OR", label: "Oregon" },
	{ value: "PA", label: "Pennsylvania" },
	{ value: "RI", label: "Rhode Island" },
	{ value: "SC", label: "South Carolina" },
	{ value: "SD", label: "South Dakota" },
	{ value: "TN", label: "Tennessee" },
	{ value: "TX", label: "Texas" },
	{ value: "UT", label: "Utah" },
	{ value: "VT", label: "Vermont" },
	{ value: "VA", label: "Virginia" },
	{ value: "WA", label: "Washington" },
	{ value: "WV", label: "West Virginia" },
	{ value: "WI", label: "Wisconsin" },
	{ value: "WY", label: "Wyoming" },
];

// for showing mailing addresses
let wheelingAddress = `35 Waltz Drive\nWheeling, IL, 60090`
let germantownAddress = `12321 Middlebrook Road, Ste 105\nGermantown, MD 20874`
// let westcostAddress = `San Fransisco, California`
let westcostAddress = `35 Waltz Drive\nWheeling, IL, 60090`
let wheelingStates = ['AL','AR','CO','IA','IL','IN','KS','KY','LA','MI','MN','MO','MS','MT','ND','NE','NM','OH','OK','SD','TN','TX','WI','WY']
let germantownStates = ['CT','DE','FL','GA','MA','MD','ME','NC','NH','NJ','NY','PA','RI','SC','VA','VT','WV']
let westcoastStates = ['AK','AZ','CA','HI','ID','NV','OR','UT','WA']

const nihCorpsAll = [36, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 295, 1080, 1081, 1209, 316, 1183, 563]

const wpsDiscountMessageCorps = [104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,138,185,279,287,295,365,532,1060,1080,1081,1209,1231,1436,1440,1442,1444,1445]

const BostonCaliCorps = [
		171, 452, 608, 1436, 455, 266, 325, 920, 326, 58, 38, 454, 771, 1071, 1125, 1280,
		1139, 695, 33, 402, 724, 442, 443, 91, 257, 584, 269, 1038, 65, 628, 403, 421, 179,
		71, 72, 100, 101, 65, 92
]

module.exports = {
	url,
	urlClient,
	usa_states,
	wheelingAddress,
	germantownAddress,
	westcostAddress,
	wheelingStates,
	germantownStates,
	westcoastStates,
	nihCorpsAll,
	muixlicensekey,
	wpsDiscountMessageCorps,
	BostonCaliCorps,
};